import  {AxiosResponse } from "axios";
import { IActiveFilter, IBaseMapLayer, ICoordinates, IMapData, IMapLayer } from "../models/map_models";
import api from './api';

const mapURL = "/map"

export const getMapDataForLayerAPI = async (
    boundingBox: Array<ICoordinates>,
    mapLayer: IMapLayer,
    activeFilters: Array<IActiveFilter>
  ): Promise<AxiosResponse<IMapData[]>> => {


    const body = {
      "index": mapLayer.index,
      "bounding_box": boundingBox,
      "filters": activeFilters,
      "limit": 500
    }
    
    return api.post(`${mapURL}/`, body)     
}


export const getMapLayersAPI = async (
): Promise<AxiosResponse<Array<IBaseMapLayer>>> => {
  return api.get(`${mapURL}/layers`)    
}
